import reducer from './reducer';

export * from './reducer';

export default reducer;
